<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Hasta"
    }
</script>

<style scoped>

</style>